import React from 'react'
import TableauPort from '../TableauPort'
import { Typography, makeStyles } from '@material-ui/core'
import LocationOnIcon from '@material-ui/icons/LocationOn'
// import { withStyles } from '@material-ui/core'

export default function Zipcode() {
	// const classes = useStyles()

	return (
		<div>
			{/*<div style={{display: 'flex', justifyContent: 'space-between'}}>
		      <Typography className={classes.title}>
		        <br />
		        <LocationOnIcon className={classes.pageIcon}/>
		        YOY SALES BY ZIP CODES
		      </Typography>
		    </div>*/}
			<TableauPort pageName={'YOY SALES BY ZIP CODES'} viz={'ZipSales/ZipSalesDaily'} />
	  	</div>
	)
}
